import { SALE_CATEGORY_URL_ID } from "@faire/retailer-shared/categories/urlId";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";

export const useIsSaleHub = (): {
  isSaleProductCategory: boolean;
} => {
  const categoryModel = useCurrentCategoryModel();

  const isSaleHub = categoryModel.urlId?.id === SALE_CATEGORY_URL_ID;
  const isPrimaryCategory = categoryModel.isPrimaryCategory;

  return {
    isSaleProductCategory: isSaleHub && !isPrimaryCategory,
  };
};
